// @ts-strict-ignore
import React from 'react';
import { Placement } from 'common/components/tooltip/types';
import { SvgIconReact } from 'common/components/svg-icon';
import { TooltipReact } from 'common/components/tooltip';
export const FieldLabelReact = (_ref: {
  fieldName: string;
  tooltipText?: string;
  subLabel?: string;
}) => {
  let {
    fieldName,
    tooltipText = null,
    subLabel = null
  }: {
    fieldName: string;
    tooltipText?: string;
    subLabel?: string;
  } = _ref;
  return <div className='pre-selected-events' data-sentry-component="FieldLabelReact" data-sentry-source-file="FieldLabelReact.tsx">
      <div className='pre-selected-events-text'>
        {fieldName}
        {subLabel ? <span className='pre-selected-events-sublabel'>{subLabel}</span> : <></>}
      </div>
      {tooltipText && <div className='info-icon-wrapper'>
          <SvgIconReact className='info-icon' icon={"info"} />
          <TooltipReact className={"info-icon-tooltip"} maxWidth={"260px"} placement={Placement.RightCenter} text={tooltipText} />
        </div>}
    </div>;
};